/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AnnualClock,
} from '../models/index';
import {
    AnnualClockFromJSON,
} from '../models/index';

/**
 *
 */
export class AnnualClockApi extends runtime.BaseAPI {

    /**
     * Get Annual Clock
     */
    async getAnnualClockApiAnnualClockGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AnnualClock>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/annual-clock`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnnualClockFromJSON(jsonValue));
    }

    /**
     * Get Annual Clock
     */
    async getAnnualClockApiAnnualClockGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AnnualClock> {
        const response = await this.getAnnualClockApiAnnualClockGetRaw(initOverrides);
        return await response.value();
    }

}
